<template>
    <div class="header-shell">
        <v-app-bar class="header" flat height="88">
            <div class="header__social">
                <v-btn
                    icon
                    aria-label="Instagram"
                    class="header__icon"
                    href="https://instagram.com/jolicoeur.mtl"
                    target="_blank"
                    rel="noopener"
                >
                    <v-icon>mdi-instagram</v-icon>
                </v-btn>
                <v-btn
                    icon
                    aria-label="Facebook"
                    class="header__icon"
                    href="https://www.facebook.com/jolicoeur.mtl/"
                    target="_blank"
                    rel="noopener"
                >
                    <v-icon>mdi-facebook</v-icon>
                </v-btn>
                <v-btn
                    icon
                    aria-label="TikTok"
                    class="header__icon"
                    href="https://www.tiktok.com/@jolicoeur.mtl"
                    target="_blank"
                    rel="noopener"
                >
                    <v-icon>mdi-tiktok</v-icon>
                </v-btn>
            </div>

            <router-link to="/" class="header__brand" aria-label="CartoMTL (Accueil)">
                <span class="sr-only">CartoMTL</span>
                <img
                    class="header__logo"
                    src="/img/cartomtl-logo.svg"
                    alt=""
                    aria-hidden="true"
                />
                <small>Le geoguess de Montréal</small>
            </router-link>

            <div class="flex-grow-1" />

            <div class="header__actions">
                <v-btn class="carto-btn carto-btn--outline">
                    S'abonner
                </v-btn>
                <v-btn
                    class="carto-btn carto-btn--outline"
                    @click="menuMobile = !menuMobile"
                >
                    Menu
                </v-btn>
            </div>
        </v-app-bar>

        <nav class="header__menu" :class="{ visible: menuMobile }">
            <a href="#jouer">Jouer</a>
            <a href="#arrondissements">Arrondissements</a>
            <a href="#palmares">Palmarès</a>
        </nav>
    </div>
</template>

<script>
export default {
    data() {
        return {
            menuMobile: false,
        };
    },
};
</script>

<style lang="scss" scoped>
.header-shell {
    background: var(--v-header-base);
    position: sticky;
    top: 0;
    z-index: 10;
    border-bottom: 2px solid var(--brand-border);
}

.header {
    z-index: 1;
    padding: 0 5%;
    background-color: var(--v-header-base) !important;
}

.header__social {
    display: flex;
    align-items: center;
    gap: 0.35rem;
}

.header__icon {
    color: var(--brand-ink) !important;
}

.header__brand {
    display: flex;
    flex-direction: column;
    margin-left: 1.5rem;
    text-decoration: none;
    color: var(--brand-ink);
    font-weight: 700;
    letter-spacing: -0.01em;
    small {
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.12em;
    }
}

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

.header__logo {
    display: block;
    height: 34px;
    width: auto;
}

.header__actions {
    display: flex;
    gap: 0.75rem;
}

.header__menu {
    display: none;
    gap: 1.25rem;
    padding: 0.8rem 5% 1rem;
    border-top: 2px solid var(--brand-border);
    background: var(--v-header-base);
    a {
        text-decoration: none;
        color: var(--brand-ink);
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.06em;
    }
    &.visible {
        display: flex;
    }
}

@media (max-width: 840px) {
    .header {
        height: auto !important;
        flex-wrap: wrap;
    }

    .header__social {
        order: 1;
    }

    .header__brand {
        order: 2;
        margin-left: 0.8rem;
        .header__logo {
            height: 30px;
        }
        small {
            display: none;
        }
    }

    .header__actions {
        order: 3;
        margin-left: auto;
        flex-wrap: wrap;
    }
}
</style>
